import { Directive } from '@angular/core';
import { StoryOutputType } from '@src/suite/common/enums/enums';

import { AssignmentIconDirective } from './assignment-icon';

@Directive({
    selector: '[st-story-icon]',
})
export class StoryIconDirective extends AssignmentIconDirective {
    protected predefinedIconsMap: { [type: string]: { icon: string; color: string } } = {
        [StoryOutputType.BROADCAST.toUpperCase()]: { icon: 'dynamic_form', color: '#321911' },
        [StoryOutputType.SOCIAL.toUpperCase()]: { icon: 'twitter', color: '#321911' },
        [StoryOutputType.WEB.toUpperCase()]: { icon: 'web', color: '#662D91' },
    };

    protected get locationID(): string {
        return this.globalTablesService.adornersIDS.StoryIcon;
    }

    protected getAdornerIcon(adorner: Adorner): string {
        return adorner.Icon;
    }
}
